// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/GascogneTS-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/ProximaNovaA-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/ProximaNovaA-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/ProximaNovaA-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/ProximaNovaA-Extrabld.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/ProximaNovaA-ExtraCondensed.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/ProximaNovaA-ExtraCondensedBld.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Vesta-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-display: fallback;
  font-family: 'Gascogne';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Gascogne';
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova Condensed';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Proxima Nova Condensed';
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
}
@font-face {
  font-display: fallback;
  font-family: 'Vesta';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
}
/* The !important must be here, because the specificity of the CSS
 generated by mui or material-ui makeStyles override this behavior */
[hidden] {
  display: none !important;
}
.bold {
  font-weight: 500;
}
.capitalize {
  text-transform: capitalize;
}
.uppercase {
  text-transform: uppercase;
}
span.green,
p.green {
  color: #25a17f;
}
a.white,
span.white,
p.white {
  color: #fff;
}
a.black,
span.black,
p.black {
  color: #444;
}
span.gray,
p.gray,
span.grey,
p.grey {
  color: #999;
}
span.gold,
p.gold {
  color: #fec25f;
}
span.red,
p.red {
  color: #a53120;
}
.no-margin {
  margin: 0;
}
span.font-normal,
p.font-normal {
  font-weight: 400;
}
div.semi-bold,
span.semi-bold,
p.semi-bold {
  font-weight: 500;
}
div.bold,
span.bold,
p.bold {
  font-weight: 600;
}
div.italic,
span.italic,
p.italic {
  font-style: italic;
}
a.size-xl,
span.size-xl,
p.size-xl {
  font-size: calc(16px * 1.25);
}
a.size-l,
span.size-l,
p.size-l {
  font-size: calc(16px * 1.125);
}
a.size-s,
span.size-s,
p.size-s {
  font-size: calc(16px * 0.875);
}
a.size-xs,
span.size-xs,
p.size-xs {
  font-size: calc(16px * 0.75);
}
a.size-xxs,
span.size-xxs,
p.size-xxs {
  font-size: calc(16px * 0.625);
}
a.underline,
span.underline,
p.underline {
  text-decoration: underline;
}
.flex {
  display: flex;
  align-items: center;
  align-content: center;
}
.no-gap {
  gap: 0;
}
.flex.min-gap {
  gap: 0.25rem;
}
.flex.gap {
  gap: 0.5rem;
}
.flex.gap.no-vertical {
  gap: 0 0.5rem;
}
.flex.extra-gap {
  gap: 1rem;
}
.flex.extra-gap.no-vertical {
  gap: 0 1rem;
}
.flex.top {
  align-items: start;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.center {
  justify-content: center;
}
.flex.middle {
  align-items: center;
}
.flex.baseline {
  align-items: baseline;
}
.flex.column {
  flex-flow: column;
}
.flex.spaced {
  justify-content: space-between;
}
.block {
  display: block;
}
.no-padding {
  padding: 0 !important;
}
a.lighten {
  color: #9fc5f9;
}
div.ellipsis,
span.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div.ellipsis-2-lines {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
div.clickable {
  cursor: 'pointer';
}
i.icon-vesta {
  color: #25a17f;
  font-family: 'Vesta';
  font-size: 20px;
  font-style: normal;
}
i.icon-vesta.disabled {
  color: #d9d9d9;
}
i.icon-vesta.pulse:before {
  content: '\\e900';
}
i.icon-vesta.scale:before {
  content: '\\e901';
}
i.icon-vesta.glucometer:before {
  content: '\\e902';
}
i.icon-vesta.heart-rate:before {
  content: '\\e903';
}
i.icon-vesta.thermometer:before {
  content: '\\e904';
}
i.icon-vesta.pulse-oximeter:before {
  content: '\\e905';
}
hr.separator {
  border-color: #d9d9d9;
  margin: 0 auto;
  width: 95%;
}
.MuiToggleButtonGroup-root {
  border-radius: 0.8rem;
}
.MuiToggleButtonGroup-root .MuiToggleButton-root:not([disabled]):not(.Mui-selected) {
  background-color: #afe2d6;
  color: #154c30 !important;
}
.MuiToggleButtonGroup-root .MuiToggleButton-root:not([disabled]).Mui-selected {
  background-color: #00a384;
  color: #fff;
}
.MuiTabs-root button,
.MuiToggleButtonGroup-root button {
  font-size: 1em;
  font-weight: 100;
  text-transform: inherit;
}
button.MuiButton-root {
  font-size: 1em;
  font-weight: 100;
  text-transform: inherit;
}
.MuiCardHeader-title {
  font-size: calc(16px * 1.5) !important;
  font-weight: 500 !important;
}
.MuiCardHeader-subheader {
  font-size: 16px !important;
  color: #bbb !important;
}
.v2-panel h1,
.v2-panel h2,
.v2-panel h3,
.v2-panel h4,
.v2-panel h5,
.v2-panel h6 {
  font-family: 'Gascogne', 'sans-serif';
  text-transform: inherit;
}
.v2-panel h1 {
  font-size: 2.5em;
}
.v2-panel h2 {
  font-size: 2em;
  font-weight: 500;
}
.v2-panel h3 {
  font-size: 1.75em;
}
.v2-panel h4 {
  font-size: 1.5em;
}
.v2-panel h5 {
  font-size: 1.25em;
}
.v2-panel h6 {
  font-size: 1em;
}
.MuiAutocomplete-popper li,
.MuiAutocomplete-popper div {
  font-size: 16px;
}
.MuiTable-root {
  font-size: 16px;
  background-color: transparent;
}
.MuiTable-root p {
  margin: 0;
}
.MuiTable-root .MuiTableBody-root,
.MuiTable-root .MuiTableFooter-root {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.24), 0px 1px 1px 0px rgba(0, 0, 0, 0.16), 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}
.MuiTable-root.row-clickable > tbody > tr:not(.detail) td.MuiTableCell-root:not(.row-no-clickable) {
  cursor: pointer;
}
.MuiTable-root .MuiTableFooter-root p,
.MuiTable-root td.MuiTableCell-root,
.MuiTable-root th.MuiTableCell-root {
  font-size: 0.875em;
}
.MuiTable-root.size-l .MuiTableFooter-root p,
.MuiTable-root.size-l td.MuiTableCell-root,
.MuiTable-root.size-l th.MuiTableCell-root {
  font-size: 0.925em;
}
.MuiTable-root.compact .MuiTableFooter-root p,
.MuiTable-root.compact td.MuiTableCell-root,
.MuiTable-root.compact th.MuiTableCell-root {
  padding: 6px 12px;
}
.MuiTable-root .MuiTableBody-root .MuiTableCell-root,
.MuiTable-root .MuiTableFooter-root .MuiTableCell-root {
  background-color: #fff;
}
.MuiTable-root .MuiTableHead-root .MuiTableCell-root,
.MuiTable-root .MuiTableBody-root .MuiTableCell-root,
.MuiTable-root .MuiTableFooter-root .MuiTableCell-root {
  border-bottom: 1px solid #f7f6f4;
}
.MuiTable-root .MuiTableFooter-root svg {
  height: 1.25em;
  margin-top: -0.25rem;
  width: 1.25em;
}
.MuiTooltip-tooltip {
  font-size: calc(16px * 0.75) !important;
  font-weight: 400 !important;
  max-width: 550px !important;
}
.bold {
  font-weight: 500;
}
.flex {
  display: flex;
  align-items: center;
  align-content: center;
}
.flex.gap {
  gap: 0.5rem;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.center {
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./../styleguide-v2/src/styles/fonts.less","webpack://./../styleguide-v2/src/styles/main.useable.less","webpack://./../styleguide-v2/src/styles/variables.less","webpack://./../styleguide-v2/src/styles/utils.less","webpack://./../styleguide-v2/src/styles/buttons.less","webpack://./../styleguide-v2/src/styles/card.less","webpack://./../styleguide-v2/src/styles/headers.less","webpack://./../styleguide-v2/src/styles/inputs.less","webpack://./../styleguide-v2/src/styles/table.less","webpack://./../styleguide-v2/src/styles/tooltip.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACCF;ADCA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACCF;ADEA;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACAF;ADEA;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACAF;ADEA;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACAF;ADEA;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACAF;ADGA;EACE,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACDF;ADIA;EACE,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACFF;ADKA;EACE,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACHF;AACA;oEACoE;ACvDpE;EACE,wBAAA;ADyDF;AEnEA;EACE,gBAAA;AFqEF;AElEA;EACE,0BAAA;AFoEF;AEjEA;EACE,yBAAA;AFmEF;AEhEA;;EAEE,cAAA;AFkEF;AE/DA;;;EAGE,WAAA;AFiEF;AE9DA;;;EAGE,WAAA;AFgEF;AE7DA;;;;EAIE,WAAA;AF+DF;AE5DA;;EAEE,cAAA;AF8DF;AE3DA;;EAEE,cAAA;AF6DF;AE1DA;EACE,SAAA;AF4DF;AEzDA;;EAEE,gBAAA;AF2DF;AExDA;;;EAGE,gBAAA;AF0DF;AEvDA;;;EAGE,gBAAA;AFyDF;AEtDA;;;EAGE,kBAAA;AFwDF;AErDA;;;EAGE,4BAAA;AFuDF;AEpDA;;;EAGE,6BAAA;AFsDF;AEnDA;;;EAGE,6BAAA;AFqDF;AElDA;;;EAGE,4BAAA;AFoDF;AEjDA;;;EAGE,6BAAA;AFmDF;AEhDA;;;EAGE,0BAAA;AFkDF;AE/CA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AFiDF;AE9CA;EACE,MAAA;AFgDF;AE7CA;EACE,YAAA;AF+CF;AE5CA;EACE,WAAA;AF8CF;AE3CA;EACE,aAAA;AF6CF;AE1CA;EACE,SAAA;AF4CF;AEzCA;EACE,WAAA;AF2CF;AExCA;EACE,kBAAA;AF0CF;AEvCA;EACE,eAAA;AFyCF;AEtCA;EACE,uBAAA;AFwCF;AErCA;EACE,mBAAA;AFuCF;AEpCA;EACE,qBAAA;AFsCF;AEnCA;EACE,iBAAA;AFqCF;AElCA;EACE,8BAAA;AFoCF;AEjCA;EACE,cAAA;AFmCF;AEhCA;EACE,qBAAA;AFkCF;AE/BA;EACE,cAAA;AFiCF;AE9BA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AFgCF;AE7BA;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;AF+BF;AE5BA;EACE,iBAAA;AF8BF;AE3BA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;AF6BF;AE1BA;EACE,cAAA;AF4BF;AEzBA;EACE,gBAAA;AF2BF;AExBA;EACE,gBAAA;AF0BF;AEvBA;EACE,gBAAA;AFyBF;AEtBA;EACE,gBAAA;AFwBF;AErBA;EACE,gBAAA;AFuBF;AEpBA;EACE,gBAAA;AFsBF;AEnBA;EACE,qBAAA;EACA,cAAA;EACA,UAAA;AFqBF;AGjQA;EACE,qBAAA;AHmQF;AGjQI;EACE,yBAAA;EACA,yBAAA;AHmQN;AGjQI;EACE,yBAAA;EACA,WAAA;AHmQN;AG9PA;;EAGI,cAAA;EACA,gBAAA;EACA,uBAAA;AH+PJ;AG3PA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;AH6PF;AIvRA;EACE,sCAAA;EACA,2BAAA;AJyRF;AIvRA;EACE,0BAAA;EACA,sBAAA;AJyRF;AK/RA;;;;;;EAOI,qCAAA;EACA,uBAAA;ALgSJ;AKxSA;EAYI,gBAAA;AL+RJ;AK3SA;EAgBI,cAAA;EACA,gBAAA;AL8RJ;AK/SA;EAqBI,iBAAA;AL6RJ;AKlTA;EAyBI,gBAAA;AL4RJ;AKrTA;EA6BI,iBAAA;AL2RJ;AKxTA;EAiCI,cAAA;AL0RJ;AM3TA;;EAEE,eAAA;AN6TF;AO/TA;EACE,eAAA;EACA,6BAAA;APiUF;AOnUA;EAKI,SAAA;APiUJ;AOtUA;;EAUI,0HAAA;APgUJ;AO3TI;EAEI,eAAA;AP4TR;AO7UA;;;EAyBI,kBAAA;APyTJ;AOtTE;;;EAII,kBAAA;APuTN;AOnTE;;;EAII,iBAAA;APoTN;AO5VA;;EA+CM,sBAAA;APiTN;AOhWA;;;EAuDM,gCAAA;AP8SN;AOrWA;EA4DI,cAAA;EACA,oBAAA;EACA,aAAA;AP4SJ;AQ1WA;EACE,uCAAA;EACA,2BAAA;EACA,2BAAA;AR4WF;AAnWA;EACE,gBAAA;AAqWF;AAlWA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAoWF;AAjWA;EACE,WAAA;AAmWF;AAhWA;EACE,eAAA;AAkWF;AA/VA;EACE,uBAAA;AAiWF","sourcesContent":["@font-face {\n  font-display: fallback;\n  font-family: 'Gascogne';\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/GascogneTS-Medium.otf) format('opentype');\n}\n@font-face {\n  font-display: fallback;\n  font-family: 'Gascogne';\n  font-style: normal;\n  font-weight: 600;\n  src: url(../fonts/GascogneTS-Medium.otf) format('opentype');\n}\n\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova';\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/ProximaNovaA-Regular.otf) format('opentype');\n}\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova';\n  font-style: normal;\n  font-weight: 500;\n  src: url(../fonts/ProximaNovaA-Semibold.otf) format('opentype');\n}\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova';\n  font-style: normal;\n  font-weight: 600;\n  src: url(../fonts/ProximaNovaA-Bold.otf) format('opentype');\n}\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova';\n  font-style: normal;\n  font-weight: 700;\n  src: url(../fonts/ProximaNovaA-Extrabld.otf) format('opentype');\n}\n\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova Condensed';\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/ProximaNovaA-ExtraCondensed.otf) format('opentype');\n}\n\n@font-face {\n  font-display: fallback;\n  font-family: 'Proxima Nova Condensed';\n  font-style: normal;\n  font-weight: 500;\n  src: url(../fonts/ProximaNovaA-ExtraCondensedBld.otf) format('opentype');\n}\n\n@font-face {\n  font-display: fallback;\n  font-family: 'Vesta';\n  font-style: normal;\n  font-weight: 400;\n  src: url(../fonts/Vesta-Regular.otf) format('opentype');\n}\n","// Custom boostrap theme\n@import './colors.less';\n@import './fonts.less';\n@import './variables.less';\n@import './utils.less';\n@import './buttons.less';\n@import './card.less';\n@import './headers.less';\n@import './inputs.less';\n@import './table.less';\n@import './tooltip.less';\n\n.bold {\n  font-weight: 500;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex.gap {\n  gap: 0.5rem;\n}\n\n.flex.wrap {\n  flex-wrap: wrap;\n}\n\n.flex.center {\n  justify-content: center;\n}\n","@fontProxima: 'Proxima Nova', 'sans-serif';\n@fontGascogne: 'Gascogne', 'sans-serif';\n\n@fontsize: 16px;\n@fontfamily: @fontProxima;\n@fonttitle: @fontGascogne;\n\n/* The !important must be here, because the specificity of the CSS\n generated by mui or material-ui makeStyles override this behavior */\n[hidden] {\n  display: none !important;\n}\n",".bold {\n  font-weight: 500;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\nspan.green,\np.green {\n  color: @iconGreen;\n}\n\na.white,\nspan.white,\np.white {\n  color: @textWhite;\n}\n\na.black,\nspan.black,\np.black {\n  color: @textBlack;\n}\n\nspan.gray,\np.gray,\nspan.grey,\np.grey {\n  color: @textGray;\n}\n\nspan.gold,\np.gold {\n  color: @gold;\n}\n\nspan.red,\np.red {\n  color: @textRed2;\n}\n\n.no-margin {\n  margin: 0;\n}\n\nspan.font-normal,\np.font-normal {\n  font-weight: 400;\n}\n\ndiv.semi-bold,\nspan.semi-bold,\np.semi-bold {\n  font-weight: 500;\n}\n\ndiv.bold,\nspan.bold,\np.bold {\n  font-weight: 600;\n}\n\ndiv.italic,\nspan.italic,\np.italic {\n  font-style: italic;\n}\n\na.size-xl,\nspan.size-xl,\np.size-xl {\n  font-size: calc(@fontsize * 1.25);\n}\n\na.size-l,\nspan.size-l,\np.size-l {\n  font-size: calc(@fontsize * 1.125);\n}\n\na.size-s,\nspan.size-s,\np.size-s {\n  font-size: calc(@fontsize * 0.875);\n}\n\na.size-xs,\nspan.size-xs,\np.size-xs {\n  font-size: calc(@fontsize * 0.75);\n}\n\na.size-xxs,\nspan.size-xxs,\np.size-xxs {\n  font-size: calc(@fontsize * 0.625);\n}\n\na.underline,\nspan.underline,\np.underline {\n  text-decoration: underline;\n}\n\n.flex {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.no-gap {\n  gap: 0;\n}\n\n.flex.min-gap {\n  gap: 0.25rem;\n}\n\n.flex.gap {\n  gap: 0.5rem;\n}\n\n.flex.gap.no-vertical {\n  gap: 0 0.5rem;\n}\n\n.flex.extra-gap {\n  gap: 1rem;\n}\n\n.flex.extra-gap.no-vertical {\n  gap: 0 1rem;\n}\n\n.flex.top {\n  align-items: start;\n}\n\n.flex.wrap {\n  flex-wrap: wrap;\n}\n\n.flex.center {\n  justify-content: center;\n}\n\n.flex.middle {\n  align-items: center;\n}\n\n.flex.baseline {\n  align-items: baseline;\n}\n\n.flex.column {\n  flex-flow: column;\n}\n\n.flex.spaced {\n  justify-content: space-between;\n}\n\n.block {\n  display: block;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\na.lighten {\n  color: #9fc5f9;\n}\n\ndiv.ellipsis,\nspan.ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\ndiv.ellipsis-2-lines {\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\ndiv.clickable {\n  cursor: 'pointer';\n}\n\ni.icon-vesta {\n  color: @iconGreen;\n  font-family: 'Vesta';\n  font-size: 20px;\n  font-style: normal;\n}\n\ni.icon-vesta.disabled {\n  color: @grayLine;\n}\n\ni.icon-vesta.pulse:before {\n  content: '\\e900';\n}\n\ni.icon-vesta.scale:before {\n  content: '\\e901';\n}\n\ni.icon-vesta.glucometer:before {\n  content: '\\e902';\n}\n\ni.icon-vesta.heart-rate:before {\n  content: '\\e903';\n}\n\ni.icon-vesta.thermometer:before {\n  content: '\\e904';\n}\n\ni.icon-vesta.pulse-oximeter:before {\n  content: '\\e905';\n}\n\nhr.separator {\n  border-color: @grayLine;\n  margin: 0 auto;\n  width: 95%;\n}\n",".MuiToggleButtonGroup-root {\n  border-radius: 0.8rem;\n  .MuiToggleButton-root:not([disabled]) {\n    &:not(.Mui-selected) {\n      background-color: @mint;\n      color: @textGreen!important;\n    }\n    &.Mui-selected {\n      background-color: @green;\n      color: @white;\n    }\n  }\n}\n\n.MuiTabs-root,\n.MuiToggleButtonGroup-root {\n  button {\n    font-size: 1em;\n    font-weight: 100;\n    text-transform: inherit;\n  }\n}\n\nbutton.MuiButton-root {\n  font-size: 1em;\n  font-weight: 100;\n  text-transform: inherit;\n}\n",".MuiCardHeader-title {\n  font-size: calc(@fontsize * 1.5) !important;\n  font-weight: 500 !important;\n}\n.MuiCardHeader-subheader {\n  font-size: @fontsize !important;\n  color: @gray !important;\n}\n",".v2-panel {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: @fonttitle;\n    text-transform: inherit;\n  }\n\n  h1 {\n    font-size: 2.5em;\n  }\n\n  h2 {\n    font-size: 2em;\n    font-weight: 500;\n  }\n\n  h3 {\n    font-size: 1.75em;\n  }\n\n  h4 {\n    font-size: 1.5em;\n  }\n\n  h5 {\n    font-size: 1.25em;\n  }\n\n  h6 {\n    font-size: 1em;\n  }\n}\n",".MuiAutocomplete-popper li,\n.MuiAutocomplete-popper div {\n  font-size: @fontsize;\n}\n",".MuiTable-root {\n  font-size: @fontsize;\n  background-color: transparent;\n\n  p {\n    margin: 0;\n  }\n\n  .MuiTableBody-root,\n  .MuiTableFooter-root {\n    box-shadow: 0px 2px 1px -1px @lightGray, 0px 1px 1px 0px rgba(0, 0, 0, 0.16),\n      0px 1px 3px 0px @lighterGray;\n  }\n\n  &.row-clickable {\n    & > tbody > tr:not(.detail) {\n      td.MuiTableCell-root:not(.row-no-clickable) {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .MuiTableFooter-root p,\n  td.MuiTableCell-root,\n  th.MuiTableCell-root {\n    font-size: 0.875em;\n  }\n\n  &.size-l {\n    .MuiTableFooter-root p,\n    td.MuiTableCell-root,\n    th.MuiTableCell-root {\n      font-size: 0.925em;\n    }\n  }\n\n  &.compact {\n    .MuiTableFooter-root p,\n    td.MuiTableCell-root,\n    th.MuiTableCell-root {\n      padding: 6px 12px;\n    }\n  }\n\n  .MuiTableBody-root,\n  .MuiTableFooter-root {\n    .MuiTableCell-root {\n      background-color: @white;\n    }\n  }\n\n  .MuiTableHead-root,\n  .MuiTableBody-root,\n  .MuiTableFooter-root {\n    .MuiTableCell-root {\n      border-bottom: 1px solid @bkgGray;\n    }\n  }\n\n  .MuiTableFooter-root svg {\n    height: 1.25em;\n    margin-top: -0.25rem;\n    width: 1.25em;\n  }\n}\n",".MuiTooltip-tooltip {\n  font-size: calc(@fontsize * 0.75) !important;\n  font-weight: 400 !important;\n  max-width: 550px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
